var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-container",staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"no-data-img",attrs:{"src":require('@/assets/images/no-data.png')}}),_c('div',{staticClass:"text"},[_vm._v("数据为空~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }